import React, { useMemo, useEffect, useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from '../config/msalConfig';

let pca = null;
let initPromise = null;

function getPca() {
    if (!pca) pca = new PublicClientApplication(msalConfig);
    return pca;
}

function initializePca(instance) {
    if (!initPromise) initPromise = instance.initialize();
    return initPromise;
}

export default function MsalProviderClient({ children }) {
    const instance = useMemo(() => getPca(), []);
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        let cbId = null;
        let cancelled = false;

        initializePca(instance).then(() => {
            if (cancelled) return;

            if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
                instance.setActiveAccount(instance.getAllAccounts()[0]);
            }

            cbId = instance.addEventCallback((event) => {
                if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                    const payload = event.payload;
                    if (payload.account) {
                        instance.setActiveAccount(payload.account);
                    }
                }
            });

            setInitialized(true);
        }).catch((error) => {
            console.error('MSAL initialize error:', error);
            if (!cancelled) setInitialized(true);
        });

        return () => {
            cancelled = true;
            if (cbId) instance.removeEventCallback(cbId);
        };
    }, [instance]);

    if (!initialized) return null;

    return <MsalProvider instance={instance}>{children}</MsalProvider>;
}
